import { Form } from 'factorial-form'

class IncidenceMessageForm extends Form {
  constructor(values: {}) {
    super(values, {
      message: 'string',
      incidence_id: 'number',
      bookkeeper_view: 'boolean',
      type: 'string',
      company_id: 'number',
    })
  }
}

export default IncidenceMessageForm
